import { createContext, useContext, useState } from 'react';
import { TimeTracking } from 'src/tabs/models/TimesheetsInterface';

interface TimeSheetsContext {
  isReadPeriod: boolean;
  setIsReadPeriod: React.Dispatch<React.SetStateAction<boolean>>;
  projectEntries: TimeTracking[];
  setProjectEntries: React.Dispatch<React.SetStateAction<TimeTracking[]>>;
  showInactivePeriods: boolean;
  setShowInactivePeriods: React.Dispatch<React.SetStateAction<boolean>>;
}

interface TimeSheetsProviderProps {
  children: React.ReactNode;
}

const TimeSheetsContext = createContext<TimeSheetsContext>(null);

export const TimeSheetsProvider = ({ children }: TimeSheetsProviderProps) => {
  const [isReadPeriod, setIsReadPeriod] = useState<boolean>(false);
  const [projectEntries, setProjectEntries] = useState<TimeTracking[]>([]);
  const [showInactivePeriods, setShowInactivePeriods] =
    useState<boolean>(false);

  return (
    <TimeSheetsContext.Provider
      value={{
        isReadPeriod,
        setIsReadPeriod,
        projectEntries,
        setProjectEntries,
        showInactivePeriods,
        setShowInactivePeriods,
      }}
    >
      {children}
    </TimeSheetsContext.Provider>
  );
};

export const useTimesheetsContext = () => {
  const context = useContext(TimeSheetsContext);
  if (!context)
    throw new Error(
      'Timesheets context must only be used in timesheets module.'
    );
  return context;
};
